<template>
  <v-container grid-list-xl fluid ma-3 text-xs-center>
    <v-layout justify-center wrap row v-if="loading">
      <v-flex xs10 headline ma-3>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-flex>
      <v-flex xs10 headline ma-3>
        Loading...
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap row v-if="!loading">
      <v-flex xs10 headline ma-3>
        Enter the Share Code
      </v-flex>
      <v-flex xs8 elevation-2 white pa-5 style="max-width:550px">
        <v-alert
          :value="error"
          type="error"
          outline
        >
          {{ error }}
        </v-alert>
        <v-text-field outline label="Code" v-model="code" class="codeInput" @keyup.enter="submitCode">
        </v-text-field>
        <v-btn
          color="secondary"
          large
          @click="submitCode"
          v-if="!loading"
        >
          Submit
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ShareService from '@/services/ShareService'

export default {
  components: {
  },
  data: function () {
    return {
      loading: null,
      error: null,
      code: null
    }
  },
  mounted: async function () {
    const loggedIn = this.$store.getters.loggedIn;
    if (!loggedIn) {
      // must be logged in to use this view
      // attach the invitation to the state and as the user to log in
      this.$store.dispatch('setLoginRedirect', {
        reason: 'Please sign in to continue.',
        path: this.$router.currentRoute.path
      })
      this.$router.push({
        name: 'login'
      })
      return;
    }

    if (this.$route.params.code) {
      const shareCode = this.$route.params.code;
      this.code = shareCode;
      this.loading = true;

      try {
        const result = await ShareService.get(this.code);

        var file = result.data.payload;

        this.$router.push({
          path: '/manipulatives/' + file.appId + '/' + shareCode
        })
      } catch (err) {
        this.error = err.response.data.error;
      }
      this.loading = false
    }
  },
  methods: {
    async submitCode () {
      if (this.code === null) {
        this.error = 'You must enter a code.'; 
      }
      
      this.loading = true;

      try {
        const result = await ShareService.get(this.code);

        var file = result.data.payload;

        this.$router.push({
          path: '/manipulatives/' + file.appId + '/' + this.code
        })
      } catch (err) {
        this.error = err.response.data.error;
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>

.codeInput >>> input {
  text-transform: uppercase;
}

</style>
